<template>
  <v-container fluid class="vaagai-page py-1 px-3 px-md-6">
    <div class="page-header mb-1">
      <div class="text-overline primary--text mb-1">Vaagai Malar</div>
      <h1 class="page-title font-weight-bold mb-1">Vaagai Malar 2026</h1>
      <div class="edition-row mb-0">
        <p class="text-body-1 mb-0">
          Read the 2026 1st edition.
        </p>
        <a
          class="download-link"
          :href="pdfUrl"
          download
          target="_blank"
          rel="noopener noreferrer"
        >
          Download
        </a>
      </div>
    </div>

    <div
      v-if="useDirectPdfView"
      class="ios-pdf-message"
    >
      <p class="mb-3">
        Your browser will open the PDF in Safari's native viewer for smooth scrolling.
      </p>
      <a
        class="open-link"
        :href="pdfUrl"
        target="_self"
        rel="noopener noreferrer"
      >
        Open PDF
      </a>
    </div>

    <div v-else class="pdf-frame">
      <iframe
        :src="pdfViewerUrl"
        title="Vaagai Malar 2026 PDF"
        frameborder="0"
        allowfullscreen
      />
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'VaagaiMalar2026',
  data() {
    return {
      pdfUrl: 'https://cltts-docs.s3.amazonaws.com/Documents/%E0%AE%B5%E0%AE%BE%E0%AE%95%E0%AF%88%E0%AE%95%E0%AF%8B%E0%AE%9F%E0%AF%88%E0%AE%AE%E0%AE%B2%E0%AE%B0%E0%AF%8D_2026.pdf',
      useDirectPdfView: false
    }
  },
  computed: {
    pdfViewerUrl() {
      return `${this.pdfUrl}#view=FitH`
    }
  },
  mounted() {
    if (typeof window === 'undefined') {
      return
    }

    const userAgent = window.navigator.userAgent || ''
    const platform = window.navigator.platform || ''
    const maxTouchPoints = window.navigator.maxTouchPoints || 0
    const isIOSDevice = /iPad|iPhone|iPod/.test(userAgent) ||
      (platform === 'MacIntel' && maxTouchPoints > 1)

    this.useDirectPdfView = isIOSDevice

    if (this.useDirectPdfView) {
      window.location.href = this.pdfUrl
    }
  }
}
</script>

<style scoped>
.vaagai-page {
  max-width: 100%;
}

.page-header {
  width: 100%;
}

.edition-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.page-title {
  font-size: 0.98rem;
  line-height: 1.15;
}

.download-link {
  color: #fdd835;
  font-size: 1rem;
  font-weight: 600;
  text-decoration: underline;
}

.download-link:hover {
  text-decoration: underline;
}

.ios-pdf-message {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-height: 220px;
  padding: 24px;
  border: 1px solid #d8d8d8;
  background: #f6f6f6;
  border-radius: 8px;
}

.open-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 18px;
  border-radius: 999px;
  background: #fdd835;
  color: #1f2937;
  font-weight: 600;
  text-decoration: none;
}

.pdf-frame {
  width: 100%;
  height: calc(100vh - 220px);
  min-height: 780px;
  border: 1px solid #d8d8d8;
  overflow: hidden;
  background: #f6f6f6;
}

.pdf-frame iframe {
  width: 100%;
  height: 100%;
}

@media (max-width: 960px) {
  .page-title {
    font-size: 0.78rem;
  }

  .pdf-frame {
    height: 75vh;
    min-height: 560px;
  }
}
</style>
